/**
 * ボタンの形（角の丸い長方形）にそって1周する線。w・h は線を描く箱の大きさ（px）。
 * 上の辺の左から時計回り。Highlight の輪が使う。
 * 参照元：Holoriba-homepage src/components/motion/pill.ts（そのまま）
 */
export function pillPath(w: number, h: number): string {
  const m = 1.5;
  const L = m;
  const T = m;
  const R = w - m;
  const B = h - m;
  const r = Math.max(0, Math.min((B - T) / 2, (R - L) / 2));
  const f = (n: number) => +n.toFixed(2);
  return `M${f(L + r)} ${f(T)}H${f(R - r)}A${f(r)} ${f(r)} 0 0 1 ${f(R - r)} ${f(B)}H${f(L + r)}A${f(r)} ${f(r)} 0 0 1 ${f(L + r)} ${f(T)}Z`;
}
